export default __webpack_public_path__ + "static/media/on.56e16d87.png";